import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=bb214e58&scoped=true&"
import script from "./Diff.vue?vue&type=script&lang=js&"
export * from "./Diff.vue?vue&type=script&lang=js&"
import style0 from "./Diff.vue?vue&type=style&index=0&id=bb214e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb214e58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
